<template>


    <div class="nav-container">
        
        <div class="nav">
            <div class="one" :style="{ backgroundColor: backgroundColor }">
                <div class="p-1">{{ title }}</div>
                <!-- <div class="p-2">
                    AP Macroeconomics focuses on the economy as a whole, covering topics like GDP, inflation,
                    <br>
                    unemployment, monetary and fiscal policy, and international trade. It helps us understand economic
                    <br>
                    systems and global markets, useful for business, finance, and policy studies.
                </div> -->
                <div class="p-2" v-html="description"></div>
                <div class="images-p">
                    <!-- <img src="../assets/images/img-p.png" alt=""> -->
                    <img :src="image" alt="">
                </div>

            </div>
        
        </div>
    </div>



</template>

<script setup>
import { ref, onMounted, computed} from 'vue'
import { useRouter } from 'vue-router'
import {  getHomeData } from '../api/modules/home'
import imgP from '../assets/images/img-p.png'

import { defineProps } from 'vue'
const props = defineProps({
    title: {
        type: String,
        default: 'Biology'
    },
    backgroundColor: {
        type: String,
        default: '#F6621F'
    },
    subject: {
        type: String,
        default: ''
    }
})

const router = useRouter()

// 根据传入的subject属性或标题确定科目类型
const subjectType = computed(() => {
    // 如果传入了subject属性，优先使用
    if (props.subject) {
        return props.subject
    }
    
    // 否则根据标题判断
    const title = props.title.toLowerCase()
    if (title.includes('calculus')) return 'calculus'
    if (title.includes('microeconomics')) return 'microeconomics'
    if (title.includes('macroeconomics')) return 'macroeconomics'
    if (title.includes('physics')) return 'physics'
    if (title.includes('biology')) return 'biology'
    if (title.includes('csp')) return 'csp'
    return 'macroeconomics' // 默认值
})






// 根据科目类型定义不同的描述内容
const subjectContent = {
    calculus: {
        description: 'AP Calculus BC covers topics including limits, derivatives, integrals, and series. It extends previous concepts with more complex functions, techniques, and applications. This course emphasizes problem-solving, critical thinking, and real-world applications, making it ideal for students interested in mathematics, engineering, or science.',
        image: imgP
    },
    microeconomics: {
        description: 'AP Microeconomics explores how individuals and businesses make decisions about resources, prices, and markets. The topics include supply and demand, market structures, consumer behavior, and government intervention. It builds critical thinking and prepares us for economics or business majors.',
        image: imgP
    },
    macroeconomics: {
        description: 'AP Macroeconomics focuses on the economy as a whole, covering topics like GDP, inflation, unemployment, monetary and fiscal policy, and international trade. It helps us understand economic systems and global markets, useful for business, finance, and policy studies.',
        image: imgP
    },
    physics: {
        description: 'AP Physics 1 is an algebra-based course covering motion, forces, energy, momentum, rotation, waves, and basic circuits. It builds scientific reasoning and problem-solving skills, ideal for students interested in science or engineering.',
        image: imgP
    },
    biology: {
        description: 'AP Biology explores life at all levels—from molecules to ecosystems. Topics include cell structure, genetics, evolution, physiology, and ecology. It emphasizes scientific inquiry and lab skills, helping us prepare for biology-related majors.',
        image: imgP
    },
    csp: {
        description: 'AP CSP introduces the basics of computer science, including programming, algorithms, data, the internet, and the impacts of computing. It encourages creativity and logical thinking, and it’s a great starting point for ones new to coding or tech.',
        image: imgP
    }
}

// 使用计算属性根据当前科目动态获取描述和图片
const description = computed(() => {
    return subjectContent[subjectType.value]?.description || subjectContent.macroeconomics.description
})

const image = computed(() => {
    return subjectContent[subjectType.value]?.image || imgP
})






//题库分类数据
const questionTypes = ref([])
// 切换 tab
const switchTab = (index) => {
    activeTab.value = index
    // 这里可以添加跳转逻辑，根据实际需求决定是否需要路由跳转
    //  router.push(tabs.value[index].path)
}


onMounted(() => {
    fetchQuestionTypes()
   
})

const fetchQuestionTypes=()=>{
    getHomeData().then(res => {
        console.log('类型列表2',res.data)
        questionTypes.value =res.data

    }).catch(error => {
        // 处理错误
        console.error('类型列表失败33:', error)
        // 添加用户友好的错误提示
        if (error.message.includes('Network Error')) {
            console.error('网络连接错误，请检查服务器是否运行正常')
        }
    })

}




</script>

<style scoped>
.nav-container {
    width: 100vw;
    display: flex;
    justify-content: center;



    .nav {
        width: 1200px;
        margin: 0px 120px 0px 120px;

        /* margin: 40px 120px 0px 120px; */
        /* border: 1px solid red; */
        .one {
            /* width: 1200px; */
            width: 100%;
            height: 270px;
            /* background: #F6621F; */
            border-radius: 12px 12px 0px 0px;
            /* 防止margin合并 */
            padding-top: 1px;
            margin-top: 40px;
            /* border: 1px solid red; */
            position: relative;

            .p-1 {
                width: 327px;
                height: 56px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 800;
                font-size: 40px;
                color: #FFFFFF;
                text-align: left;
                margin: 40px 0px 20px 24px;



            }

            .p-2 {
                width: 1000px;
                height: 84px;
                font-family: PingFang SC, PingFang SC;

                font-size: 20px;
                color: #FFFFFF;
                text-align: left;
                margin: 20px 849px 40px 24px;

            }
        }

        .two {
            width: 100%;
            height: 64px;
            background: #000000;
            border-radius: 0px 0px 0px 0px;
            display: flex;

            .tab-item {
                margin: 20px 0px 19px 24px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 18px;
                color: #FFFFFF;
                text-align: left;
                cursor: pointer;
                padding: 0 10px;
                transition: all 0.3s ease;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .tab-item:first-child {
                margin-left: 24px;
            }

            .tab-item:not(:first-child) {
                margin-left: 155px;
            }

            .tab-item:hover {
                opacity: 0.8;

            }

            .tab-name {
                white-space: nowrap;
            }

            .tab-name.active-name {
                font-weight: 800;
            }




            .triangle {
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-bottom: 10px solid white;
                margin-top: 8px;
            }
        }


        .images-p {
            width: 150px;
            height: 136px;
            /* border: 1px dashed #999; */
            /* border: 1px solid red; */
            position: absolute;
            top:72px ;
            right: 39px;

            img {
                width: 150px;
                height: 136px;
            }
        }
    }
}
</style>